import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import SliderRow from "./SliderRow";
import StyledSlider from "./StyledSlider";
import {StoreContext} from "../stores/context";

export default observer((props) => {
  const store = useLocalObservable(() => ({some_prop: ''}));
  const rootStore = useContext(StoreContext);

  useEffect(() => {
    // mount
    return () => {
      // unmount
    }
  }, []);

  return (
    <SliderRow title={props.title} tooltip={props.tooltip}>
      <StyledSlider {...props} value={rootStore.tarif_values[props.code]} onChange={(newVal)=>{
        runInAction(()=>{
          rootStore.tarif_values[props.code]=newVal;
        });
      }} />
    </SliderRow>
  )

});